import { render, staticRenderFns } from "./Ficha.vue?vue&type=template&id=5a82f8b8&scoped=true&"
import script from "./Ficha.vue?vue&type=script&lang=js&"
export * from "./Ficha.vue?vue&type=script&lang=js&"
import style0 from "./Ficha.vue?vue&type=style&index=0&id=5a82f8b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82f8b8",
  null
  
)

export default component.exports